// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"275cbdf0","493":"7f9dd2c1"}[chunkId] + ".chunk.css";
};